<template>
    <div class="tabmenu-container">
        <div class="tabmenu-header">
            <ul class="tabmenu-menu">
                <li class="tabmenu-menu-item"
                    v-for="tab in tabs"
                    :key="tab"
                    :class="{'tab-head--active': activeTab === tab}"
                    @click="switchTab(tab)">
                    <slot :name="tabHeadSlotName(tab)">
                        {{ tab }}
                    </slot>
                </li>
            </ul>
        </div>

        <div class="tabmenu-main">
            <div class="tabmenu-panel">
                <slot :name="tabPanelSlotName">
                </slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'

export default defineComponent({
    name: "TabMenu",
    props: {
        tabs: {
            type: Array as () => string[],
            required: true
        },
        initialTab: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const activeTab = ref(props.initialTab)

        const tabPanelSlotName = computed(() => `tab-panel-${activeTab.value}`)

        const tabHeadSlotName = (tabName: string): string => {
            return `tab-head-${tabName}`
        }

        const switchTab = (tabName: string): void => {
            activeTab.value = tabName
        }

        return {
            activeTab,
            tabPanelSlotName,
            tabHeadSlotName,
            switchTab
        }
    }
})
</script>